import styles from './RecordsCard.module.css';
import { AiFillHeart } from 'react-icons/ai';
import { FaEye, FaRegClock } from 'react-icons/fa';
import { BiCommentDetail } from 'react-icons/bi';
import DataFilter from '../DataFilter/DataFilter';
import Action from '../Action/Action';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
const RecordsCard = ({ data }) => {
  const dispatch = useDispatch();

  const {
    type,
    description,
    students,
    staff,
    lessons,
    footerNote,
    time,
    createdAt,
    likes,
    views,
    comments,
    labels = {
      students: 'Students Tagged',
      staff: 'Staff Tagged',
      lessons: 'Lessons',
    },
    image,
  } = data;
  const handleEdit = () => {};

  const handleDelete = () => {
    dispatch(openModal('delete'));
    console.log('Delete action triggered');
  };

  const handleShare = () => {
    // dispatch(openModal("share"));
    console.log('Share action triggered');
  };

  const handleActionSelect = (option) => {
    switch (option) {
      case 'Edit':
        handleEdit();
        break;
      case 'Delete':
        handleDelete();
        break;
      default:
        break;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.type}>{type}</span>
        <div className={styles.more}>
          <Action options={['Edit', 'Delete']} onSelect={handleActionSelect} />
        </div>
      </div>

      <div className={styles.cardBody}>
        <div className={styles.contentRow}>
          <img src={image} alt="report" className={styles.image} />
          <div className={styles.descriptionCard}>
            <span className={styles.title}>Description</span>
            <p className={styles.description}>{description}</p>
          </div>
        </div>

        {students && (
          <div className={styles.tagRow}>
            <b>{labels.students}</b>
            <DataFilter initialFilters={students} />
          </div>
        )}

        {staff && (
          <div className={styles.tagRow}>
            <b>{labels.staff}</b>
            <DataFilter initialFilters={staff} />
          </div>
        )}

        {lessons && (
          <div className={styles.tagRow}>
            <b>{labels.lessons}</b>
            <DataFilter initialFilters={lessons} />
          </div>
        )}

        {/* <div className={styles.footerNote}>
          <p>{footerNote}</p>
        </div> */}
        {footerNote && (
          <div className={styles.descriptionCard}>
            <span className={styles.title}>Note</span>
            <p className={styles.description}>{footerNote}</p>
          </div>
        )}

        <div className={styles.footerStats}>
          <div className={styles.stats}>
            <span
              onClick={() => {
                console.log('likes');
              }}
            >
              <AiFillHeart /> {likes}
            </span>
            <span
              onClick={() => {
                console.log('CHECK PERSONS');
              }}
            >
              <FaEye /> {views}
            </span>
            <span>
              <BiCommentDetail /> {comments}
            </span>
          </div>
          <div className={styles.timestamp}>
            <span>
              <FaRegClock /> {time} . {createdAt}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecordsCard;
